<template lang="html">
  <div class="serve-detail">
    <div v-sticky="{ zIndex: 10 }">
      <ul class="detail-tab">
        <li :class="{ active: tabIndex === 0 }" @click="changeTab(0)">
          服务详情
        </li>
        <li :class="{ active: tabIndex === 1 }" @click="changeTab(1)">
          常见问题
        </li>
        <!-- <li @click="goAnchor('#guess_you_like')">猜你喜欢</li> -->
      </ul>
    </div>
    <div class="detail-tab-content">
      <div class="specifications" v-show="tabIndex === 0">
        <ul class="item-cells">
          <li class="item-cell">
            <div class="item-cell-hd">商品名称</div>
            <div class="item-cell-bd">{{ product.spuName }}</div>
          </li>
          <li class="item-cell">
            <div class="item-cell-hd">商品编码</div>
            <div class="item-cell-bd">{{ product.spuId }}</div>
          </li>
          <!-- <li class="item-cell">
                        <!-- <div class="item-cell-hd">{{item.attr_name}}</div> -->
          <!-- <div class="item-cell-bd" v-html="product.content"></div> -->
          <!-- </li> -->
        </ul>
        <div
          class="video-box"
          v-if="product.cmmdtyVideo && mainConfig.videoPosition === 'bottom'"
        >
          <videoPanel
            :src="product.cmmdtyVideo"
            :poster="product.cmmdtyVideoCover"
          ></videoPanel>
        </div>
        <div class="pDetail" v-xhtml="product.content"></div>
      </div>
      <div class="product-question" v-show="tabIndex === 1">
        <ul>
          <li v-for="question in questionList">
            <p class="question">
              <i>问</i><span>{{ question.question }}</span>
            </p>
            <p class="answer">
              <i>答</i><span>{{ question.answer }}</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VueSticky from '@/plugins/directive-sticky'
import videoPanel from '../common/video'

export default {
  props: {
    product: {
      type: Object
    }
  },
  data() {
    return {
      tabIndex: 0
    }
  },
  methods: {
    changeTab(index) {
      this.tabIndex = index
      if (this.tabIndex === 1) {
        this.$$tracker('100101', '20000', 21011)
      } else {
        this.$$tracker('100101', '20000', 21010)
      }
    }
    // goAnchor(selector) {
    //     const anchor = document.querySelector(selector)
    //     if (anchor) {
    //         document.body.scrollTop = anchor.offsetTop
    //         document.documentElement.scrollTop = anchor.offsetTop
    //     }
    // }
  },
  directives: {
    sticky: VueSticky
  },
  computed: {
    ...mapState(['questionList', 'mainConfig']),
    productDetail() {
      // let detail_html = ''
      // const detail = this.product.detail_list.filter(ele => ele.detailchannel === 1)
      // if (detail.length > 0) {
      //     detail_html += detail[0].detailinfo || ''
      // }
      // return detail_html
      return this.product.content
    },
    video() {
      try {
        let json = {}
        const video = this.product.detail_list.filter(
          ele => ele.detailchannel === 6
        )
        if (video.length > 0 && video[0].detailinfo) {
          json = JSON.parse(video[0].detailinfo)
        }
        return json
      } catch (e) {
        console.log(e)
        return {}
      }
    }
  },
  components: {
    videoPanel
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.serve-detail {
  background: #fff;
  margin-top: rem(21px);

  .detail-tab {
    display: flex;
    align-items: center;
    justify-content: center;
    @include border(bottom);
    background: #fff;

    li {
      // flex: 1;
      height: rem(80px);
      line-height: rem(80px);
      font-size: rem(32px);
      text-align: center;
      margin-right: rem(250px);

      &.active {
        color: #ff397e;
        border-bottom: 1px solid #ff397e;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .detail-tab-cont {
    // padding: rem(20px);
  }
  .specifications {
    .item-cell {
      padding-bottom: 0;
      &:last-child {
        padding-bottom: rem(20px);
      }
    }
    .item-cell-hd {
      width: rem(170px);
    }
  }
  .product-question {
    padding: rem(20px);
    font-size: rem(28px);

    li {
      margin-bottom: rem(40px);
      p {
        display: flex;
      }
      i {
        display: inline-block;
        width: rem(40px);
        height: rem(40px);
        margin-right: rem(10px);
        text-align: center;
        line-height: rem(40px);
        border-radius: rem(6px);
        color: #fff;
      }
      span {
        flex: 1;
        line-height: 1.3;
        word-wrap: break-word;
        word-break: break-all;
      }
      &:last-child {
        margin-bottom: rem(20px);
      }
    }
    .question {
      align-items: center;
      i {
        background: #ff397e;
      }
    }
    .answer {
      margin-top: rem(20px);
      color: #666;
      i {
        position: relative;
        background: #f5a623;

        &::after {
          content: '';
          position: absolute;
          right: -2px;
          bottom: 0;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0 3px 4px 3px;
          border-color: transparent transparent #f5a623 transparent;
        }
      }
    }
  }
  .pDetail {
    width: 100%;
    text-align: center;
    overflow: hidden;

    img {
      max-width: 100%;
    }
  }
  .video-box {
    display: block;
    height: rem(450px);
    margin-top: rem(20px);
    video {
      width: 100%;
    }
  }
}
</style>
